import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { Store } from '../../../store/list/types';

/**
 * Set showNotWatchedPopoverInfo boolean to false to avoid reshowing the popover when the dom updates
 */
export const disableNotWatchedPopoverInfo = (store: Store): void => {
  const { setShowNotWatchedPopoverInfo } = store.getState();

  setShowNotWatchedPopoverInfo(false);
  setIsNotWatchedPopoverInfoSeen();
};

/**
 * Set in local storage if the user have seen the popover info for not watched by default
 */
function setIsNotWatchedPopoverInfoSeen() {
  LocalStorage.set('isPopoverNotWatchedSeen', true);
}
